
import bildKeller from '@/assets/icons/standort_keller.svg';
import bildErdgeschoss from '@/assets/icons/standort_erdgeschoss.svg';
import bildDachgeschoss from '@/assets/icons/standort_dachgeschoss.svg';

export const heatingLocations = [
    { name: 'Keller', available: true, value: 'keller', api: '21006', image: bildKeller },
    { name: 'Erdgeschoss', available: true, value: 'erdgeschoss', api: '21007',  image: bildErdgeschoss },
    { name: 'Ober- oder Dachgeschoss', available: false, value: 'obergeschoss', api: '21008', image: bildDachgeschoss },
];

export const heatingLocationsApi = {parameter: '17988', type: 'value_choice'}

